var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityHoist = function SvgAccessibilityHoist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M16.596 5.83c3.81.207 8.06 1.277 12.456 3.888m-28.104 0S5.935 6.39 13.224 5.861M3.736 8.337v3.63m22.601-3.625v3.626M16.492 1.91v4.456a.52.52 0 0 1-.51.51h-1.977a.52.52 0 0 1-.51-.51V1.91M2.252 13.9v-1.08a.52.52 0 0 1 .51-.51h1.826a.51.51 0 0 1 .505.51v2.101m19.781-.305V12.82a.52.52 0 0 1 .511-.511h1.826c.28.004.507.23.511.51v2.101"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M27.721 13.294v2.061c0 7.004-5.73 12.735-12.734 12.735S2.252 22.36 2.252 15.355v-2.06"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M24.874 13.327v1.997c0 5.439-4.45 9.888-9.887 9.888s-9.894-4.45-9.894-9.888v-1.997"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m6.275 19.747-.311-.477s8.733 7.406 18.07 0l-.31.34"
  }))));
};
export default SvgAccessibilityHoist;